import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** crossed-out eye, hide. Decorative line icon; always pair with a visible text label. */
export function EyeOffIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <path d="M4 4l16 16" />
      <path d="M10.7 6.1A8.6 8.6 0 0 1 12 6c6 0 9.5 6 9.5 6a16.6 16.6 0 0 1-2.3 3" />
      <path d="M6.6 6.6C4.1 8.1 2.5 12 2.5 12s3.5 6 9.5 6a8.7 8.7 0 0 0 3.4-.7" />
      <path d="M10 10a2.8 2.8 0 0 0 4 4" />
    </IconSvg>
  )
}
